import styled from 'styled-components';

export const SectionDivider = styled.div`
  border-top: 2px solid darkgrey;
  grid-column: 1 / 1; /* this code makes the row stretch to entire width of the grid */
`;
